"use strict";

globalThis.Hologram.pendingScripts ??= [];

globalThis.Hologram.pendingScripts.push({
  digest: new URL(document.currentScript.src).pathname.match(/-([^-]+)\.js$/)[1],
  define: (deps) => {
    const {
      Bitstring,
      ERTS,
      HologramBoxedError,
      HologramInterpreterError,
      Interpreter,
      MemoryStorage,
      Type,
      Utils,
    } = deps;

Interpreter.defineElixirFunction("Config.Provider", "__struct__", 0, "public", [{params: (context) => [], guards: [], body: (context) => {
return Type.map([[Type.atom("__struct__"), Type.atom("Elixir.Config.Provider")], [Type.atom("config_path"), Type.atom("nil")], [Type.atom("extra_config"), Type.list([])], [Type.atom("providers"), Type.atom("nil")], [Type.atom("prune_runtime_sys_config_after_boot"), Type.atom("false")], [Type.atom("reboot_system_after_config"), Type.atom("false")], [Type.atom("validate_compile_env"), Type.atom("false")]]);
}}]);

Interpreter.defineElixirFunction("Config.Provider", "__struct__", 1, "public", [{params: (context) => [Type.variablePattern("kv_0")], guards: [], body: (context) => {
return Elixir_Enum["reduce/3"](context.vars.kv_0, Type.map([[Type.atom("__struct__"), Type.atom("Elixir.Config.Provider")], [Type.atom("config_path"), Type.atom("nil")], [Type.atom("extra_config"), Type.list([])], [Type.atom("providers"), Type.atom("nil")], [Type.atom("prune_runtime_sys_config_after_boot"), Type.atom("false")], [Type.atom("reboot_system_after_config"), Type.atom("false")], [Type.atom("validate_compile_env"), Type.atom("false")]]), Type.anonymousFunction(2, [{params: (context) => [Type.tuple([Type.variablePattern("key_1"), Type.variablePattern("val_2")]), Type.variablePattern("map_3")], guards: [], body: (context) => {
return Elixir_Map["merge/2"](context.vars.map_3, Type.map([[context.vars.key_1, context.vars.val_2]]));
}}], context, "-__struct__/1-fun-0-"));
}}]);
  },
});

document.dispatchEvent(new CustomEvent("hologram:scriptLoaded"));